<template>
  <v-container fluid>
    <v-card elevation="8" class="pa-4">
      <!-- 🔹 Filtros (compactos y profesionales) -->
      <v-card outlined class="mb-4">
        <v-card-text class="py-4">
          <v-row dense>
            <!-- Importantes: Desde / Hasta -->
            <v-col cols="12" md="6">
              <MxDateTimePicker
                class="gf-ctrl mx-dtp-anchor"
                v-model="filtros.inicio"
                label="Desde (fecha y hora)"
                :dense="true"
                :disabled="cargando"
                :max-date="maxInicioDate"
              />
            </v-col>

            <v-col cols="12" md="6">
              <MxDateTimePicker
                class="gf-ctrl mx-dtp-anchor"
                v-model="filtros.fin"
                label="Hasta (fecha y hora)"
                :dense="true"
                :disabled="cargando"
                :min-date="minFinDate"
              />
            </v-col>

            <!-- Expandibles: Más filtros -->
            <v-col cols="12">
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <div class="d-flex align-center">
                      <v-icon small class="mr-2">mdi-tune-variant</v-icon>
                      <span class="mr-3">Más filtros (opcional)</span>
                      <!-- Resumen compacto de selección -->
                      <v-chip x-small class="mr-1" v-if="filtros.instancias.length">Máqs: {{ filtros.instancias.length }}</v-chip>
                      <v-chip x-small class="mr-1" v-if="filtros.grupoMaquinas.length">Grupos: {{ filtros.grupoMaquinas.length }}</v-chip>
                      <v-chip x-small class="mr-1" v-if="filtros.areas.length">Áreas: {{ filtros.areas.length }}</v-chip>
                      <v-chip x-small class="mr-1" v-if="filtros.ordenes.length">OTs: {{ filtros.ordenes.length }}</v-chip>
                      <v-chip x-small class="mr-1" v-if="filtros.idsCategorias.length">Cats: {{ filtros.idsCategorias.length }}</v-chip>
                    </div>
                    <template v-slot:actions>
                      <v-icon>mdi-chevron-down</v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="filtros.instancias"
                          :items="instancias"
                          item-value="idMaquinaIns"
                          :item-text="nombreMaquina"
                          label="Máquina(s)"
                          clearable multiple chips deletable-chips
                          :error-messages="errorMaquina"
                          @focus="errorMaquina = ''"
                        />
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="filtros.grupoMaquinas"
                          :items="grupoMaquina"
                          item-value="idMaquinaTipo"
                          item-text="nombre"
                          label="Grupo de Máquinas"
                          clearable multiple chips deletable-chips
                          :error-messages="errorMaquina"
                          @focus="errorMaquina = ''"
                        />
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-autocomplete
                          v-model="filtros.areas"
                          :items="areas"
                          item-value="idArea"
                          :item-text="nombreArea"
                          label="Área(s)"
                          clearable multiple chips deletable-chips
                          :error-messages="errorArea"
                          @focus="errorArea = ''"
                        />
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-autocomplete
                          v-model="filtros.ordenes"
                          label="Orden(es) de Trabajo"
                          :loading="loadingODTS"
                          :disabled="loadingODTS || loading"
                          :items="ordenesTrabajo"
                          item-text="nombre"
                          item-value="idTrabajoOrden"
                          multiple chips deletable-chips clearable hide-details
                          @change="onOrdenesChange"
                        />
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-autocomplete
                          v-model="filtros.idsCategorias"
                          label="Categoría(s)"
                          :items="dataCategorias"
                          item-value="idMaquinaCategoria"
                          item-text="nombre"
                          :return-object="false"
                          multiple chips deletable-chips clearable hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Acciones -->
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3 justify-space-between">
          <div class="text-caption grey--text">
            Selecciona rango y presiona <strong>Consultar</strong>.
          </div>
          <div class="d-flex align-center">
            <v-btn color="primary" :loading="loading" @click="consultar">
              <v-icon left>mdi-magnify</v-icon> Consultar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <download-btn
        color="blue darken-1"
        text 
        @click="descargarReporteTiempos"
        label="Descargar Reporte<br>de Tiempos por Maquina"
      ></download-btn>
    <v-progress-linear
      v-if="loading"
			color="primary"
			indeterminate
		></v-progress-linear>
      <!-- 🔹 KPIs superiores -->
      <v-card class="mt-2" elevation="4">
        <v-card-text class="py-4">
          <div class="text-center text-h5 mb-4">TIEMPO TOTAL DE COMPORTAMIENTO DE MÁQUINA</div>
          <v-row class="text-center">
            <v-col cols="12" md="3">
              <div class="kpi-title kpi-activo">ACTIVO</div>
              <div class="kpi-value">{{ fmtKpi(roundHalfUp(totales.activo), totales.total) }}</div>
            </v-col>
            <v-col cols="12" md="3">
              <div class="kpi-title kpi-paro">PARO</div>
              <div class="kpi-value">{{ fmtKpi(roundHalfUp(totales.paro), totales.total) }}</div>
            </v-col>
            <v-col cols="12" md="3">
              <div class="kpi-title kpi-inactivo">INACTIVO</div>
              <div class="kpi-value">{{ fmtKpi(roundHalfUp(totales.inactivo), totales.total) }}</div>
            </v-col>
            <v-col cols="12" md="3">
              <div class="kpi-title">TOTAL</div>
              <div class="kpi-value">
                {{ fmtKpiTotal(roundHalfUp(totales.total)) }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 🔹 Cuadrantes -->
      <v-row class="mt-4">

        <!-- Q1: Pastel -->
        <v-col cols="12" md="6">
          <v-card elevation="6" class="h-100">
            <v-card-text>
              <div class="text-center text-h6 mb-2">
                PORCENTAJE GLOBAL DE TIEMPO ACTIVO, INACTIVO Y PARO DE MÁQUINAS
              </div>
              <apexchart
                ref="pie"
                type="donut"
                height="600"
                :options="pieOptions"
                :series="pieSeries"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Q2: Barras por Máquina -->
        <v-col cols="12" md="6">
          <v-card elevation="6" class="h-100">
            <v-card-text>
              <div class="text-center text-h6 mb-2">
                DESGLOSE DE TIEMPO ACTIVO, INACTIVO Y PARO POR MÁQUINA
              </div>
              <div class="chart-outer">
                <div class="chart-inner" :style="{ width: chartPixelWidth + 'px' }">
                  <apexchart
                    ref="barMaquina"
                    type="bar"
                    height="600"
                    width="100%"
                    :options="chartOptions"
                    :series="series"
                  />
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Q3: Registro de Máquina por Área (espacio reservado) -->
        <v-col cols="12" md="6" class="mt-4">
        <v-card elevation="6" class="h-100">
            <v-card-text>
            <div class="text-center text-h6 mb-2">REGISTRO DE MÁQUINA POR ÁREA</div>
            <div class="chart-outer">
                <div class="chart-inner" :style="{ width: '100%' }">
                <apexchart
                    ref="barAreaMachines"
                    type="bar"
                    height="600"
                    width="100%"
                    :options="chartAreaMachineOptions"
                    :series="seriesAreaMachines"
                />
                </div>
            </div>
            </v-card-text>
        </v-card>
        </v-col>

        <!-- Q4: Promedio por Área -->
        <v-col cols="12" md="6" class="mt-4">
          <v-card elevation="6" class="h-100">
            <v-card-text>
              <div class="text-center text-h6 mb-2">
                PORCENTAJE DE TIEMPO ACTIVO, INACTIVO Y PARO DE MÁQUINAS POR ÁREA
              </div>
              <div class="chart-outer">
                <div class="chart-inner" :style="{ width: chartAreaPixelWidth + 'px' }">
                  <apexchart
                    ref="barArea"
                    type="bar"
                    height="600"
                    width="100%"
                    :options="chartAreaOptions"
                    :series="seriesArea"
                  />
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>

    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
//import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import DownloadBtn from '../../DownloadBtn.vue';
import moment from "moment";
import MxDateTimePicker from '../../MxDateTimePicker.vue';

export default {
  components: {
    apexchart: VueApexCharts,
    DownloadBtn,
    MxDateTimePicker
    //VueCtkDateTimePicker,
  },
  data() {
    const hoyInicio = moment().startOf('day').format('YYYY-MM-DD HH:mm'); // 00:00 local
    const hoyAhora  = moment().format('YYYY-MM-DD HH:mm');                // ahora local
    return {
      forceActivoOnlyOnOt: false, // <- bandera para forzar solo Activo
      loading: false,
      loadingODTS: false,
      loadingCAT: false,
      porMaquinaPorArea: [],
      porMaquina: [],      // lo llenas desde tu EP
      porArea: [],      // lo llenas desde tu EP
      seriesArea: [],
      dataCategorias: [],
      pieSeries: [],       // [activo, paro, inactivo]
      ordenesTrabajo: [],
      IdArticulosCategoria: [],
      pieOptions: {
        chart: { type: 'donut' },
        labels: ['Activo No. de Horas', 'Paro No. de Horas', 'Inactivo No. de Horas'],
        legend: {
          position: 'left',
          formatter: (seriesName, opts) => {
            const v = opts.w.globals.series[opts.seriesIndex] || 0;
            const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0) || 1;
            const pct = (v * 100) / total;
            return `${seriesName}: ${v.toLocaleString('en-US', { maximumFractionDigits: 2 })} hrs. (${pct.toFixed(2)}%)`;
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const value = opts.w.globals.series[opts.seriesIndex] || 0;
            return `${value.toLocaleString('en-US', { maximumFractionDigits: 2 })} hrs.\n(${val.toFixed(2)}%)`;
          },
          dropShadow: { enabled: false },
          style: { fontSize: '12px' },
        },
        tooltip: {
          y: {
            formatter: (v) =>
              `${(Number(v) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })} hrs.`,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%',
              labels: {
                show: true,
                name: {
                  show: true,
                  offsetY: -8,
                  formatter: (name) => name, // "Activo No. de Horas", etc.
                },
                value: {
                  show: true,
                  offsetY: 8,
                  formatter: (val) =>
                    `${(Number(val) || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })} hrs.`,
                },
                total: {
                  show: true,
                  label: 'Total Horas',
                  formatter: (w) => {
                    const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    return `${total.toLocaleString('en-US', { maximumFractionDigits: 0 })} hrs.`;
                  },
                },
              },
            },
          },
        },
        colors: ["#28a745", "#dc3545", "#007bff"],
        // Si los nombres largos del encabezado se salen, dale margen:
        grid: { padding: { top: 10, bottom: 10, left: 10, right: 10 } },
      },
      filtros: { inicio: hoyInicio, fin: hoyAhora, instancias: [], areas: [] , ordenes: [], idsCategorias: [], grupoMaquinas: []},
      grupoMaquina: [],
      instancias: [],
      areas: [],
      series: [],
      seriesAreaMachines: [],
      chartAreaOptions: {
        chart: { stacked: true, toolbar: { show: true }, stackType: '100%' },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "80%",
            barGap: "15%",
            barHeight: "100%",
            borderRadius: 4,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            // val ya viene como % porque usamos stackType:'100%'
            const raw = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex] || 0;
            const pct = Number(val) || 0;
            const hrs = Number(raw) || 0;
            // 🔹 % grande (arriba) y horas debajo
            return `${pct.toFixed(1)}%`;
          },
          style: { fontSize: '26px', fontWeight: 800 }, // un poquito más grande el %
          dropShadow: { enabled: false },
        },
        stroke: { show: true, width: 0, colors: ["#fff"] },
        xaxis: {
          type: "category",
          categories: [],
          labels: {
            rotate: -45, rotateAlways: true,
            hideOverlappingLabels: false, trim: false,
            minHeight: 60, style: { fontSize: "12px" },
          },
        },
        yaxis: {
          min: 0, max: 100, tickAmount: 5,
          labels: {
            formatter: (v) => `${(Number(v)||0).toFixed(0)}%`, // eje en %
          },
          title: { text: '% del tiempo' },
        },
        grid: { padding: { bottom: 10 } },
        // Tooltip con % y hrs (hrs desde los datos crudos)
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            const cat = w.globals.labels[dataPointIndex] ?? '';
            const name = w.config.series[seriesIndex].name ?? '';
            const raw = w.config.series[seriesIndex].data[dataPointIndex] ?? 0; // horas
            const pct = (w.globals.seriesPercent?.[seriesIndex]?.[dataPointIndex]) ?? null;
            const pctTxt = pct != null ? `${pct.toFixed(2)}%` : '';
            return `<div class="apex-tooltip">
              <div><strong>${cat}</strong></div>
              <div>${name}: <strong>${pctTxt}</strong> • ${Number(raw).toLocaleString('en-US', {maximumFractionDigits:2})} hrs.</div>
            </div>`;
          }
        },
        legend: { position: "left" },
        colors: ["#28a745", "#dc3545", "#007bff"], // Activo, Paro, Inactivo
      },
      chartOptions: {
        chart: {
            stacked: true,
            toolbar: {show: true}
        },
        plotOptions: {
            legend: {
                position: 'left'
            },
            bar: {
                horizontal: false,
                columnWidth: '80%',
                barGap: "5%",         // 🔹 Forzamos separación entre grupos de barras
                barHeight: "100%",     // 🔹 Mantiene la proporción de altura
                borderRadius: 2,
                dataLabels: { position: 'center' } // <- clave para que no se oculten
            }
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => this.hrsToHMS(val),
          style: { fontSize: '20px' },
        },
        //dataLabels: {
        //  enabled: true,
        //  formatter: function (val) {
        //    const n = Number(val) || 0;
        //    return `${n.toLocaleString('en-US')} hrs.`;
        //  },
        //  style: { fontSize: '24px' },
        //},
        stroke: {
            show: true,
            width: 1,               // 🔹 Sin borde para que la barra se vea compacta
            colors: ["#fff"],
        },
        xaxis: {
          type: "category",
          categories: [],
          labels: {
            rotate: -45, rotateAlways: true,
            hideOverlappingLabels: false, trim: false,
            minHeight: 60, style: { fontSize: "12px" },
          },
        },
        yaxis: {
          labels: {
            formatter: (v) => this.hrsToHMS(v),
            //formatter: (v) => `${(Number(v) || 0).toLocaleString('en-US')} hrs.`,
          },
        },
        grid: {
            padding: {
                bottom: 10,            // ← deja espacio debajo para nombres largos
            },
        },
        tooltip: {
          y: {
            formatter: (v) => this.hrsToHMS(v),
          },
        },
        //tooltip: {
        //  y: {
        //    formatter: (v) => `${(Number(v) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })} hrs.`,
        //  },
        //},
        legend: { position: "left" },
        colors: ["#28a745", "#dc3545", "#007bff"], // Activo, Paro, Inactivo
      },
      chartAreaMachineOptions: {
        chart: { stacked: true, toolbar: { show: true } },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "80%",
                barGap: "15%",
                barHeight: "100%",
                borderRadius: 4,
            },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            const n = Number(val) || 0;
            return `${n.toLocaleString('en-US')} hrs.`;
          },
          style: { fontSize: '24px' },
        },
        stroke: { show: true, width: 0, colors: ["#fff"] },
        xaxis: {
            type: "category",
            categories: [],
            labels: {
                rotate: -45, rotateAlways: true,
                hideOverlappingLabels: false, trim: false,
                minHeight: 60, style: { fontSize: "12px" },
            },
        },
        yaxis: {
          labels: {
            formatter: (v) => `${(Number(v) || 0).toLocaleString('en-US')} hrs.`,
          },
        },
        grid: {
            padding: {
                bottom: 10,            // ← deja espacio debajo para nombres largos
            },
        },
        tooltip: {
          y: {
            formatter: (v) => `${(Number(v) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })} hrs.`,
          },
        },
        legend: { position: "top" },
        colors: ["#28a745", "#dc3545", "#007bff"], // Activo, Paro, Inactivo
      },
    };
  },

  computed: {
    cargando() {
      return this.loading || this.loadingODTS || this.loadingCAT;
    },
    minFinDate () {
      if (!this.filtros.inicio) return null;
      return String(this.filtros.inicio).split(/[ T]/)[0];
    },
    maxInicioDate () {
      if (!this.filtros.fin) return null;
      return String(this.filtros.fin).split(/[ T]/)[0];
    },
    totales() {
      const pickSec = (m, keyMin, keySec) =>
        (m[keySec] != null ? Number(m[keySec]) : Math.round((Number(m[keyMin]) || 0) * 3600));

      const a = this.porMaquina.reduce((s,m)=> s + pickSec(m, 'activoMin',   'activoSec'), 0);
      const p = this.porMaquina.reduce((s,m)=> s + pickSec(m, 'paroMin',     'paroSec'), 0);
      const i = this.porMaquina.reduce((s,m)=> s + pickSec(m, 'inactivoMin', 'inactivoSec'), 0);
      const total = a + p + i;
      return { activo: a, paro: p, inactivo: i, total };
    },
    chartPixelWidth() {
      const n = this.chartOptions.xaxis.categories.length || 1;
      const PER_CAT = 120;                // ancho por categoría (ajústalo)
      return Math.max(100, n * PER_CAT);
    },
    chartAreaPixelWidth() {
      const n = this.chartAreaOptions.xaxis.categories.length || 1;
      const PER_CAT = 160;
      return Math.max(900, n * PER_CAT);
    },
  },
  watch: {
    'filtros.inicio'(nuevo) {
      if (!nuevo || !this.filtros.fin) return;

      const ini = moment(nuevo, 'YYYY-MM-DD HH:mm', true);
      const fin = moment(this.filtros.fin, 'YYYY-MM-DD HH:mm', true);

      if (!ini.isValid() || !fin.isValid()) return;

      // Si inicio queda después de fin → ajusto fin al mismo valor de inicio
      if (fin.isBefore(ini)) {
        this.filtros.fin = ini.format('YYYY-MM-DD HH:mm');
      }
    },
    'filtros.fin'(nuevo) {
      if (!nuevo || !this.filtros.inicio) return;

      const fin = moment(nuevo, 'YYYY-MM-DD HH:mm', true);
      const ini = moment(this.filtros.inicio, 'YYYY-MM-DD HH:mm', true);

      if (!ini.isValid() || !fin.isValid()) return;

      // Si fin queda antes de inicio → ajusto inicio al mismo valor de fin
      if (ini.isAfter(fin)) {
        this.filtros.inicio = fin.format('YYYY-MM-DD HH:mm');
      }
    },
  },
  methods: {
    secToHMS(secIn) {
      let sec = Math.max(0, Math.round(Number(secIn) || 0));
      const hh = String(Math.floor(sec / 3600)).padStart(2,'0');
      const mm = String(Math.floor((sec % 3600) / 60)).padStart(2,'0');
      const ss = String(sec % 60).padStart(2,'0');
      return `${hh}:${mm}:${ss}`;
    },
    hrsToHMS(h) {
      const s = Math.round((Number(h) || 0) * 3600);
      const hh = String(Math.floor(s / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      return `${hh}:${mm}:${ss}`;
    },
    fmtKpi(v, total) {
      const n = Math.max(0, Number(v) || 0);
      const t = Math.max(0, Number(total) || 0);
      const pct = t > 0 ? (n * 100) / t : 0;
      return `${this.secToHMS(n)} (${pct.toFixed(2)}%)`;
    },
    fmtKpiTotal(v) {
      const n = Math.max(0, Number(v) || 0);
      return `${this.secToHMS(n)} (100%)`;
    },
    fmtHrs(v, digits = 0) {
      const n = Number(v) || 0;
      return `${n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })} hrs.`;
    },
    async consultar() {
      if (!this.filtros.inicio || !this.filtros.fin) {
        this.$toast.error("Debes seleccionar 'Desde' y 'Hasta'.");
        return;
      }
      this.loading = true;
      try {
        // refresca OTs en base al rango (como ya lo hacías)
        await this.getOrdenesTrabajo();
        await this.fetchData();
      } finally {
        this.loading = false;
      }
    },

    limpiarAvanzados() {
      this.filtros.instancias = [];
      this.filtros.grupoMaquinas = [];
      this.filtros.areas = [];
      this.filtros.ordenes = [];
      this.filtros.idsCategorias = [];
    },
    showOnlyActivo() {
      // Oculta Paro e Inactivo en las barras
      const charts = [this.$refs.barMaquina, this.$refs.barArea, this.$refs.barAreaMachines];
      charts.forEach(c => {
        const chart = c?.chart;
        if (!chart) return;
        try {
          chart.showSeries('Activo');
          chart.hideSeries('Paro');
          chart.hideSeries('Inactivo');
        } catch(_) {}
      });

      // Para el pastel, dejamos las otras series en 0 (visual "solo Activo")
      const [a, p, i] = this.pieSeries.map(Number);
      this.pieSeries = [a || 0, 0, 0];
    },

    showAllSeries() {
      // Muestra todas las series en las barras
      const charts = [this.$refs.barMaquina, this.$refs.barArea, this.$refs.barAreaMachines];
      charts.forEach(c => {
        const chart = c?.chart;
        if (!chart) return;
        try {
          chart.showSeries('Activo');
          chart.showSeries('Paro');
          chart.showSeries('Inactivo');
        } catch(_) {}
      });

      // Restablece el pastel a sus totales reales
      const [a, p, i] = [
        this.totales.activo,
        this.totales.paro,
        this.totales.inactivo
      ].map(this.roundHalfUp);
      this.pieSeries = [a, p, i];
    },

    applyDefaultVisibility() {
      // Llamar esto después de cargar/actualizar datos
      if (this.forceActivoOnlyOnOt) this.showOnlyActivo();
      else this.showAllSeries();
    },
    descargarReporteTiempos() {
      const datetime = moment().format("YYYYMMDDHHmmss");

      const params = new URLSearchParams();
      params.append("inicio", this.filtros.inicio);
      params.append("fin", this.filtros.fin);
      (this.filtros.instancias || []).forEach(id => params.append("idsMaquinaIns", id));
      (this.filtros.areas || []).forEach(id => params.append("idsArea", id));
      (this.filtros.ordenes || []).forEach(id => params.append("ordenes", id));
      (this.filtros.idsCategorias || []).forEach(id => params.append("idsCategorias", id));
      (this.filtros.grupoMaquinas || []).forEach(id => params.append("grupoMaquinas", id));

      const url = `/Reportes/XLSTiemposPorMaquinaReal?${params.toString()}`;

      this.$utils.axios.downloadFile(
        url,
        "GET",
        `reporte-maquina-tiempos-${datetime}.xlsx`,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
    },
    // formateador para KPIs
    fmt(v) { return `${(Number(v) || 0).toFixed(2)} hrs`; },
    async onFiltroChange() {
      // valida que haya rango de fechas antes de pedir
      if (!this.filtros.inicio || !this.filtros.fin) return;
      this.loading = true;
      this.getOrdenesTrabajo();
      this.fetchData();
    },
    async fetchData() {
      if (!this.filtros.inicio || !this.filtros.fin) {
        this.$toast.error("Debes seleccionar fechas.");
        this.loading = false;
        return;
      }

      await this.$nextTick();
      await new Promise(r => requestAnimationFrame(r));
      // (opcional) otro frame:
      // await new Promise(r => requestAnimationFrame(r));

      const MIN_VISIBLE_MS = 350;
      const t0 = performance.now();

      try {
        const params = new URLSearchParams();
        params.append("inicio", this.filtros.inicio);
        params.append("fin", this.filtros.fin);
        this.filtros.instancias.forEach((id) => params.append("idsMaquinaIns", id));
        this.filtros.areas.forEach((id) => params.append("idsArea", id));
        this.filtros.ordenes.forEach((id) => params.append("ordenes", id));
        this.filtros.idsCategorias.forEach((id) => params.append("idsCategorias", id));
        this.filtros.grupoMaquinas.forEach((id) => params.append("grupoMaquinas", id));

        const { data } = await axios.post(`/Reportes/GetTiemposPorMaquina?${params.toString()}`);

        const porMaquina = (data.porMaquina ?? data.porMaquina ?? []).slice();
        const porArea = (data.porArea ?? data.PorArea ?? []).slice();
        const porMaquinaPorArea = (data.porMaquinaPorArea ?? data.PorMaquinaPorArea ?? []).slice();

        this.porMaquina = porMaquina;
        this.porArea    = porArea;
        this.porMaquinaPorArea = porMaquinaPorArea;

        await this.refreshPie();

        
        await new Promise(r => setTimeout(r, 0));
        // categorías = nombres de máquina y re-asignamos el objeto para que Vue/Apex lo reactive
        const categoriesMaquinas = porMaquina.map(m =>
            m.maquina ?? m.Maquina ?? m.maquinaNombre ?? m.MaquinaNombre ?? "—"
        );
        const categoriesAreas = porArea.map(a =>
            a.areaNombre ?? a.AreaNombre ?? a.area ?? a.Area ?? "Sin área"
        );
        this.pieOptions = {
          ...this.pieOptions,
          labels: ['Activo', 'Paro', 'Inactivo'],
          legend: { ...this.pieOptions.legend,
            formatter: (seriesName, opts) => {
              const v = opts.w.globals.series[opts.seriesIndex] || 0;
              const total = opts.w.globals.seriesTotals.reduce((a,b)=>a+b,0) || 1;
              const pct = (v * 100) / total;
              return `${seriesName}: ${this.secToHMS(v)} (${pct.toFixed(2)}%)`;
            }
          },
          dataLabels: { ...this.pieOptions.dataLabels,
            formatter: (val, opts) => {
              const v = opts.w.globals.series[opts.seriesIndex] || 0;
              return `${this.secToHMS(v)}\n(${val.toFixed(2)}%)`;
            }
          },
          tooltip: { y: { formatter: (v) => this.secToHMS(v) } },
          plotOptions: { pie: { donut: { labels: {
            ...this.pieOptions.plotOptions.pie.donut.labels,
            value: { formatter: (val) => this.secToHMS(val) },
            total: { ...this.pieOptions.plotOptions.pie.donut.labels.total,
              formatter: (w) => this.secToHMS(w.globals.seriesTotals.reduce((a,b)=>a+b,0))
        } } } } }
        };
        this.chartOptions = {
          ...this.chartOptions,
          yaxis: { labels: { formatter: v => this.secToHMS(v) } },
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: categoriesMaquinas
          },
          dataLabels: { enabled: true, formatter: v => this.secToHMS(v) },
          tooltip: { y: { formatter: v => this.secToHMS(v) } }
        };

        this.chartAreaOptions = {
          ...this.chartAreaOptions,
          yaxis: { // sigue mostrando % porque el stack 100% ya convierte
            min: 0, max: 100, tickAmount: 5,
            labels: { formatter: (v) => `${(Number(v)||0).toFixed(0)}%` }
          },
          xaxis: {
            ...this.chartAreaOptions.xaxis,
            categories: categoriesAreas
          },
          tooltip: {
            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const cat = w.globals.labels[dataPointIndex] ?? '';
              const name = w.config.series[seriesIndex].name ?? '';
              const rawSec = w.config.series[seriesIndex].data[dataPointIndex] ?? 0;
              const pct = (w.globals.seriesPercent?.[seriesIndex]?.[dataPointIndex]) ?? null;
              const pctTxt = pct != null ? `${pct.toFixed(2)}%` : '';
              return `<div class="apex-tooltip">
                <div><strong>${cat}</strong></div>
                <div>${name}: <strong>${pctTxt}</strong> • ${this.secToHMS(rawSec)}</div>
              </div>`;
            }
          }
        };

        this.series = [
          { name: "Activo",   data: this.porMaquina.map(m => m.activoSec ?? Math.round((m.activoMin||0)*3600)) },
          { name: "Paro",     data: this.porMaquina.map(m => m.paroSec   ?? Math.round((m.paroMin||0)*3600)) },
          { name: "Inactivo", data: this.porMaquina.map(m => m.inactivoSec ?? Math.round((m.inactivoMin||0)*3600)) },
        ];

        function fmtHMS(sec){
          sec = Math.max(0, Math.round(Number(sec)||0));
          const h = Math.floor(sec/3600);
          const m = Math.floor((sec%3600)/60);
          const s = sec%60;
          return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
        }
        this.seriesArea = [
          { name: "Activo",   data: this.porArea.map(a => a.activoSec   ?? Math.round((a.activoMin   || 0)*3600)) },
          { name: "Paro",     data: this.porArea.map(a => a.paroSec     ?? Math.round((a.paroMin     || 0)*3600)) },
          { name: "Inactivo", data: this.porArea.map(a => a.inactivoSec ?? Math.round((a.inactivoMin || 0)*3600)) },
        ];
        await this.refreshAreaMachineChart();

        this.$nextTick(() => {
          this.$refs.barMaquina?.chart?.updateOptions(
            { xaxis: { categories: categoriesMaquinas } },
            false,  // redrawPaths
            true    // animate
          );
        });
      } catch (e) {
        console.error(e);
        this.$toast.error("No se pudieron cargar los datos.");
      } finally {
        const elapsed = performance.now() - t0;
        const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
        setTimeout(() => (this.loading = false), wait);
      }
    },
    async onOrdenesChange() {
      const ids = Array.isArray(this.filtros.ordenes) ? this.filtros.ordenes : [];
      this.forceActivoOnlyOnOt = ids.length > 0;

      if (!ids.length) {
        await Promise.all([this.getMaquinasIns(), this.getGruposMaquinas()]);
        return;
      }

      await Promise.all([this.cargarMaquinasPorOT(ids), this.cargarGruposPorOT(ids)]);
    },
    async cargarGruposPorOT(idsOT) {
      try {
        const qs = new URLSearchParams();
        idsOT.forEach(id => qs.append('idsOT', id));

        const { data } = await axios.get(`/TrabajoOrdenes/GruposPorOT?${qs.toString()}`);
        const gruposRaw = Array.isArray(data.grupos) ? data.grupos : [];

        // Normaliza nombres de propiedad por si vienen en PascalCase
        this.grupoMaquina = gruposRaw.map(g => ({
          idMaquinaTipo: g.idMaquinaTipo ?? g.IdMaquinaTipo ?? g.id_tipo ?? g.IdTipo,
          nombre:        g.nombre        ?? g.Nombre        ?? g.descripcion ?? '—'
        }));

        // this.filtros.grupoMaquinas = [];
      } catch (e) {
        console.error(e);
        this.$toast?.error('No se pudieron cargar los grupos de la(s) ODT(s).');
      }
    },
    async cargarMaquinasPorOT(idsOT) {
      try {
        const qs = new URLSearchParams();
        idsOT.forEach(id => qs.append('idsOT', id));

        const { data } = await axios.get(`/TrabajoOrdenes/RecursosPorOT?${qs.toString()}`);
        const maquinasRaw = Array.isArray(data.maquinas) ? data.maquinas : [];

        this.instancias = maquinasRaw.map(m => ({
          idMaquinaIns: m.idMaquinaIns ?? m.IdMaquinaIns,
          nombre:       m.nombre       ?? m.Nombre ?? '',
          marca:        m.marca        ?? m.Marca  ?? '',
          modelo:       m.modelo       ?? m.Modelo ?? '',
          idMaquinaTipo:m.idMaquinaTipo?? m.IdMaquinaTipo ?? null
        }));

      } catch (e) {
        console.error(e);
        this.$toast?.error('No se pudieron cargar las máquinas de la(s) ODT(s).');
      }
    },

    async cargarRecursosPorOT(idsOT) {
      try {
        // Puedes mandar varias OTs repitiendo el query param
        const qs = new URLSearchParams();
        idsOT.forEach(id => qs.append('idsOT', id));

        const { data } = await axios.get(`/TrabajoOrdenes/RecursosPorOT?${qs.toString()}`);

        const grupos = Array.isArray(data.grupos) ? data.grupos : [];
        const maquinas = Array.isArray(data.maquinas) ? data.maquinas : [];

        this.grupoMaquina = grupos;
        this.instancias = maquinas;

        this.filtros.grupoMaquinas = grupos.map(g => g.idMaquinaTipo);
        this.filtros.instancias = maquinas.map(m => m.idMaquinaIns);
      } catch (e) {
        console.error(e);
        this.$toast?.error('No se pudieron cargar grupos y máquinas de la OT.');
      }
    },
    async refreshPie() {
      const a = this.totales.activo;
      const p = this.totales.paro;
      const i = this.totales.inactivo;
      this.pieSeries = [
        this.totales.activo,
        this.totales.paro,
        this.totales.inactivo
      ];
    },
    async buildGlobalTotals() {
        const t = this.porMaquina.reduce((acc, m) => {
        acc.activo   += Number(m.activoMin || 0);
        acc.paro     += Number(m.paroMin || 0);
        acc.inactivo += Number(m.inactivoMin || 0);
        return acc;
        }, { activo: 0, paro: 0, inactivo: 0 });

        t.total = t.activo + t.paro + t.inactivo;
        return t;
    },
    getMaquinasIns() {
			axios
				.get("/MaquinaInstancias")
				.then((response) => {
					this.instancias = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
	  },
    getCategorias() {
      axios
        .get("/MaquinaCategorias")
        .then((response) => {
          this.dataCategorias = response.data;
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getAreas() {
      axios.get("/Areas")
        .then((response) => {
          this.areas = response.data || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGruposMaquinas() {
			axios
				.get("/MaquinaTipos")
				.then((response) => {
					this.grupoMaquina = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
    getOrdenesTrabajo() {
      this.loadingODTS = true;

      const qs = new URLSearchParams();
      if (this.filtros.inicio) qs.append("FechaDesde", this.filtros.inicio); // "YYYY-MM-DD"
      if (this.filtros.fin)    qs.append("FechaHasta",    this.filtros.fin);    // "YYYY-MM-DD"
      if (Array.isArray(this.filtros.areas)) {
        this.filtros.areas.forEach(id => {
          qs.append("IdsArea", id);
        });
      }
      qs.append("otsCerradas", true); // si lo necesitas

      axios
        .get(`/TrabajoOrdenes/ListarOTMT?${qs.toString()}`)
        .then((response) => {
          this.ordenesTrabajo = response.data || [];
        })
        .catch(console.log)
        .finally(() => {
          this.loadingODTS = false;
        });
    },
    async refreshAreaMachineChart() {
      // Áreas seleccionadas en el filtro
      const selectedAreas = Array.isArray(this.filtros.areas) ? this.filtros.areas : [];
      const hasSelection = selectedAreas.length > 0;

      const rows = (this.porMaquinaPorArea || []).filter(r => {
        const idArea = (r.idArea ?? r.IdArea ?? null);
        return !hasSelection || selectedAreas.includes(idArea);
      });

      const itemsRaw = rows.map(r => {
        return {
          label:  r.area ?? r.Area ?? r.areaNombre ?? r.AreaNombre ?? "Sin área",
          idArea: (r.idArea ?? r.IdArea ?? null),
          activo:   r.activoSec   ?? Math.round((Number(r.activoMin   ?? r.ActivoMin   ?? 0))*3600),
          paro:     r.paroSec     ?? Math.round((Number(r.paroMin     ?? r.ParoMin     ?? 0))*3600),
          inactivo: r.inactivoSec ?? Math.round((Number(r.inactivoMin ?? r.InactivoMin ?? 0))*3600),
        };
      });

      if (!itemsRaw.length) {
        this.chartAreaMachineOptions = {
          ...this.chartAreaMachineOptions,
          yaxis: { labels: { formatter: (v) => this.secToHMS(v) } },
          dataLabels: { enabled: true, formatter: (val) => this.secToHMS(val) },
          tooltip: { y: { formatter: (v) => this.secToHMS(v) } },
        };
        this.seriesAreaMachines = [
          { name: "Activo",   data: itemsRaw.map(i => i.activo) },
          { name: "Paro",     data: itemsRaw.map(i => i.paro) },
          { name: "Inactivo", data: itemsRaw.map(i => i.inactivo) },
        ];
        return;
      }
      const xCats = (itemsRaw.length ? itemsRaw.map(i => i.label || '—') : []);
      const cats       = itemsRaw.map(i => i.label || '—');
      const sActivo    = itemsRaw.map(i => this.roundHalfUp(i.activo));
      const sParo      = itemsRaw.map(i => this.roundHalfUp(i.paro));
      const sInactivo  = itemsRaw.map(i => this.roundHalfUp(i.inactivo));

      this.chartAreaMachineOptions = {
        ...this.chartAreaMachineOptions,
        xaxis: {
          ...this.chartAreaMachineOptions.xaxis,
          categories: xCats
        },
        yaxis: { labels: { formatter: v => this.secToHMS(v) } },
        dataLabels: { enabled: true, formatter: v => this.secToHMS(v) },
        tooltip: { y: { formatter: v => this.secToHMS(v) } },
      };

      this.seriesAreaMachines = [
        { name: "Activo",   data: sActivo },
        { name: "Paro",     data: sParo },
        { name: "Inactivo", data: sInactivo },
      ];
    },
    roundHalfUp(value) {
        const int = Math.floor(value);
        const decimal = value - int;
        return decimal >= 0.5 ? int + 1 : int;
    },
    initialize() {
		this.getMaquinasIns();
        this.getAreas();
        this.getOrdenesTrabajo();
        this.getCategorias();
        this.getGruposMaquinas();
	},
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    nombreArea: (area) => `${area.nombre}`,
  },

  mounted() {
    this.initialize();
    this.consultar();
  },
  
};
</script>

<style scoped>
.v-card-title { font-weight: 700; font-size: 18px; }

.chart-outer{
  width: 100%;
  overflow-x: auto;      /* scroll horizontal */
  overflow-y: hidden;
}

.chart-inner{
  display: inline-block; /* respeta el ancho variable */
  min-width: 1200px;
}

/* Asegura que Apex ocupe el 100% del inner */
:deep(.apexcharts-canvas),
:deep(.apexcharts-svg){
  width: 100% !important;
  min-width: 100% !important;
}

/* Evita que v-card-text recorte el overflow en algunos temas */
:deep(.v-card-text){ overflow: visible; }

.kpi-title{ font-weight:700; letter-spacing:.5px; }
.kpi-value{ font-size:26px; font-weight:800; margin-top:6px; }
.kpi-activo{ color:#28a745; }   /* verde */
.kpi-paro{ color:#dc3545; }     /* rojo */
.kpi-inactivo{ color:#007bff; } /* azul */

.chart-outer{ width:100%; overflow-x:auto; overflow-y:hidden; }
.chart-inner{ display:inline-block; min-width:900px; }
.placeholder-area{
  height: 350px; display:flex; align-items:center; justify-content:center;
  color:#888; border:2px dashed #ccc; border-radius:12px;
}
/* misma altura visual que tus inputs */
.gf-ctrl .v-input__control,
.gf-ctrl .v-input__slot { min-height: 40px !important; }

/* corrige posicionamiento del popup si usas portales/attach */
.mx-dtp-anchor { position: relative; }
.mx-dtp-anchor .ctk-container,
.mx-dtp-anchor .v-menu__content { position: absolute !important; top: 100% !important; left: 0 !important; }

/* z-index alto por si se esconde detrás de cards */
.v-ctk .ctk-container { z-index: 3000 !important; }
</style>